"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bot_chat_1 = require("../../messages/bot-chat");

var notification_1 = require("../../messages/notification");

var base_1 = __importDefault(require("../base"));

var methods_factory_1 = require("../methods-factory");

var BotClient =
/*#__PURE__*/
function (_base_1$default) {
  _inherits(BotClient, _base_1$default);

  function BotClient(options) {
    var _this;

    _classCallCheck(this, BotClient);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BotClient).call(this, options));
    _this.acceptBotMessage = methods_factory_1.AcceptMessageFactory(bot_chat_1.BotMessage, 1);
    _this.unacceptBotMessage = methods_factory_1.UnacceptMessageFactory(bot_chat_1.BotMessage);
    _this.acceptNotification = methods_factory_1.AcceptMessageFactory(notification_1.InternalNotification, 1);
    _this.sendBotMessage = methods_factory_1.SendMessageFactory();
    return _this;
  }

  return BotClient;
}(base_1.default);

exports.BotClient = BotClient;
exports.default = BotClient;